import React, { useEffect } from 'react';
import Hero from '../components/Hero';
import ServicesGrid from '../components/ServicesGrid';
import ServicesList from '../components/ServicesList';
import CallToAction from '../components/CallToAction';
import useScrollReveal from '../hooks/useScrollReveal';
import Seo from '../components/seo';

<Seo 
  title="B2B Lead Generation Services | Email & Cold Calling | InviteEngine" 
  description="Explore our full suite of B2B lead generation services. From targeted email outreach to discovery calls, we build high-performing pipelines for SMBs."
  path="/services" 
>
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Service",
      "serviceType": "B2B Lead Generation",
      "provider": {
        "@type": "worldwideOrganization",
        "name": "InviteEngine",
        "address": {
          "@type": "PostalAddress",
          "addressCountry": "Worldwide"
        }
      },
      "areaServed": {
        "@type": "Country",
        "name": "Worldwide"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Outreach Services",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Inbox to Invite",
              "description": "We craft highly-targeted email campaigns designed to spark interest and secure real meetings."
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Dials to Discovery Calls",
              "description": "Our team connects with the right decision-makers over the phone, setting up meaningful discovery calls. "
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Full Spectrum Outreach",
              "description": "Want the best of both worlds? We coordinate email and phone campaigns so your outreach is cohesive, effective, and maximizes engagement across channels."
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Reach at Scale",
              "description": "For teams that want to accelerate their pipeline, we combine smart targeting with higher volumes of emails and calls. "
            }
          }
        ]
      }
    })}
  </script>
</Seo>

export default function ServicesPage() {
  useScrollReveal();
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <main>
      
      <ServicesGrid />
      <ServicesList />
      {/* <CallToAction /> */}
    </main>
  );
}
